import { ICountryInfoDTO, ISystemUserContactInfoDTO, ISystemUserDetailDTO } from "api/swagger/ApiClient";
import { UserContact } from "model/business-types";

export interface TransferUserRolesModel {
  transferFrom: ISystemUserDetailDTO;
  countriesApprove: CountryCheckListItem[];
  countriesContact: CountryCheckListItem[];
  delegateApprovers: UserCheckListItem[];
  transferTo: UserContact;
}

export interface CountryCheckListItem {
  country: ICountryInfoDTO;
  checked: boolean;
}

export interface UserCheckListItem {
  user: ISystemUserContactInfoDTO;
  checked: boolean;
}
